import StudentsCSLP from "./StudentsCSLP";
import TeachersCSLP from "./TeachersCSLP";

const CSLP = (props) => {
  return (
    <>

      <div className="container-fluid mt-30">
        <div className="row">
          <div className="col-md-12">
            <div className="card mb-1">
              <div className="card-header">
                <h3 className="card-title">Sync CSLP</h3>
                <div className="align-self-center"></div>
              </div>
              <div className="card-body"></div>
            </div>
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <StudentsCSLP />
                  </div>
                  <div className="col-md-6">
                    <TeachersCSLP />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CSLP;
